import { render } from "./LostCallsCard.vue?vue&type=template&id=908d19ee"
import script from "./LostCallsCard.vue?vue&type=script&lang=js"
export * from "./LostCallsCard.vue?vue&type=script&lang=js"
script.render = render

export default script